import React, { useEffect } from "react";
import ContactForm from "./ContactForm";
import Aos from "aos";
import "aos/dist/aos.css";

const Contact = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div className=" p-8 font-serif " id="contact">
      <h1 className="p-8 md: mt-20 text-center text-[#E84949] text-2xl font-bold">
        Send me a message📨
      </h1>
      <div
        data-aos="flip-right"
        className=" w-[100%] lg:flex justify-around  items-center gap-2"
      >
        <div className=" ">
          <img src="/message.png" alt="" />
        </div>
        <div className="lg:w-[80%]">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;
